import type { FC } from "react";

import { Alert } from "@sentricmusic/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useUIStateStore } from "@/store/uiStateStore";

import useDomainConfigAuth from "../api/sanity/queries/getSiteConfigWithDomain";

type FormErrorProps = {
  mutationError?: string;
  validationError?: string;
};

const FormError: FC<FormErrorProps> = (props: FormErrorProps) => {
  const [showError, setShowError] = useState(false);
  const toggleError = () => setShowError(!showError);
  const { mutationError, validationError } = props;
  const { data: domainConfig } = useDomainConfigAuth();
  const supportEmail = domainConfig?.support_email;
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { t } = useTranslation("security");

  return (
    <>
      {mutationError != null && mutationError.length > 0 && (
        <Alert variant="destructive" className="inline-block w-4/5 mt-2 mb-8 text-sm">
          <p className="mb-4">
            {t("security:mutation-error-message")}
          </p>
          <p>
            {t("security:for-support-prefix")}
            {" "}
            {!isTunecore ? (
              <a
                className="underline"
                href={
                  (supportEmail != null)
                    ? `mailto:${domainConfig?.support_email}`
                    : "mailto:support@sentricmusic.com"
                }
              >
                {(supportEmail != null)
                  ? domainConfig?.support_email
                  : "support@sentricmusic.com"}
              </a>
            ) : (
              <a
                className="underline"
                target="_blank"
                href="https://support.tunecore.com/hc/en-us/requests/new?ticket_form_id=662748"
                rel="noreferrer"
              >
                tunecore.com/support
              </a>
            )}
          </p>
          <button
            type="button"
            onClick={toggleError}
            className="px-4 py-2 mt-4 mb-4 font-bold text-white rounded-lg bg-action-secondary"
          >
            {showError ? t("security:hide-error") : t("security:show-error")}
          </button>
          {showError && <div className="mt-2">{mutationError}</div>}
        </Alert>
      )}

      {validationError != null && validationError.length > 0 && (
        <Alert variant="destructive" className="inline-block w-4/5 mt-2 mb-8 text-base">
          {validationError}
        </Alert>
      )}
    </>
  );
};

export default FormError;
